const emailSessionKey = 'ford-pro-email';

const module = {
  namespaced: true,
  state: () => ({
    email: '',
  }),
  mutations: {
    setEmail(state, email) {
      sessionStorage.setItem(emailSessionKey, email);
      state.email = email;
    },
  },
  getters: {
    email: (state) => {
      if (state.email) return state.email;
      const sessionEmail = sessionStorage.getItem(emailSessionKey);
      if (sessionEmail) return sessionEmail;
      return '';
    },
  },
};

export default module;
